import type { RadioGroupContext } from './types'
import { createContext } from '../../utils/react-helpers'

const [RadioGroupProvider, useRadioGroupContext] =
  createContext<RadioGroupContext>({
    name: 'RadioGroupContext',
    strict: false
  })

export { RadioGroupProvider, useRadioGroupContext }
